<template>
  <Transition name="app-loader">
    <div v-if="!ready" class="app-loader" aria-label="Loading">
      <img class="app-loader__logo" :src="logo" alt="Mora" />
    </div>
  </Transition>
  <SiteNavigation />
  <div class="min-h-[100dvh]">
    <RouterView v-slot="{ Component }">
      <Transition name="fade" mode="out-in">
        <component v-if="ready" :is="Component" />
      </Transition>
    </RouterView>
  </div>
  <SiteFooter />
  <SiteModal />
  <Popup />
  <Gdpr />
</template>

<script lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'

import logo from '@/assets/images/logo.svg'
import Gdpr from '@/components/blocks/Gdpr.vue'
import Popup from '@/components/modal/Popup.vue'
import SiteModal from '@/components/modal/SiteModal.vue'
import SiteNavigation from '@/components/navigation/SiteNavigation.vue'
import SiteFooter from '@/components/sections/SiteFooter.vue'
import router from '@/router'
import { useContentStore } from '@/stores/content.ts'

export default {
  name: 'App',
  components: { Gdpr, Popup, SiteModal, SiteNavigation, SiteFooter },
  setup() {
    const store = useContentStore()
    const { ready } = storeToRefs(store)

    onMounted(async () => {
      await router.isReady()
      await store.init()
    })

    return { logo, ready }
  },
}
</script>

<style scoped>
.app-loader {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-burgundy);
}

.app-loader__logo {
  width: 12rem;
  max-width: 55vw;
  animation: loader-dim 1.6s ease-in-out infinite;
}

.app-loader-leave-active {
  transition: opacity 500ms ease-in-out;
}

.app-loader-leave-to {
  opacity: 0;
}

@keyframes loader-dim {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.35;
  }
}
</style>
